<template>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-students" class="sidebar__link">
      <UserIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.students-list") }}</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/kurator-groups" class="sidebar__link">
      <UsersIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.groups-list") }}</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-mentors" class="sidebar__link">
      <AcademicCapIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.mentors") }}</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper" v-if="isKuratorManager">
    <router-link to="/kurator-stats" class="sidebar__link">
      <ChartBarIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.kurator-stats") }}</p>
    </router-link>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import {
  UserIcon,
  UsersIcon,
  AcademicCapIcon,
  ChartBarIcon,
} from "@heroicons/vue/24/outline";

const { t } = useI18n();
const isKuratorManager = localStorage.getItem("is_kurator_manager") === "true";
</script>
